export const SIDEBAR_ZINDEX = '0'
export const MOBILE_NAV_BAR_ZINDEX = '9999'
export const MODAL_OVERLAY_ZINDEX = '10000'
export const MODAL_ZINDEX = '10001'
export const POPPER_ZINDEX = '10002'
export const ANNOUNCEMENT_ZINDEX = '10003'
export const TOOLTIP_ZINDEX = '10004'
export const MOBILE_APP_MODAL_ZINDEX = '10005'
export const BACKGROUND_ZINDEX = '-10'

export const zIndexMap = {
  announcement: ANNOUNCEMENT_ZINDEX,
  background: BACKGROUND_ZINDEX,
  mobileAppModal: MOBILE_APP_MODAL_ZINDEX,
  mobileNavBar: MOBILE_NAV_BAR_ZINDEX,
  modal: MODAL_ZINDEX,
  modalOverlay: MODAL_OVERLAY_ZINDEX,
  popper: POPPER_ZINDEX,
  sidebar: SIDEBAR_ZINDEX,
  tooltip: TOOLTIP_ZINDEX,
}
